import React, { useState, useEffect } from "react";
import { Avatar, Card, Table, Tag, Space, message } from "antd";
import { UserOutlined, UserSwitchOutlined } from "@ant-design/icons";
import PageHeader from "../../components/headers/PageHeader";
import userService from "../../services/UserService";
// import ModalCrearUsuario from "../../components/modales/Perfil/components/ModalCrearUsuario";
import MenuBotonUsuarios from "../../components/modales/Perfil/components/MenuBotonUsuarios";
import { useUser } from "../../context/UserContext";
import getOptions from "../../utils/getOptions";

const ListaUsuarios = () => {
  const [usuarios, setUsuarios] = useState([]);
  const [photoUrls, setPhotoUrls] = useState({});
  const [loading, setLoading] = useState(true);

  const user = useUser();

  const loadPhotoUrls = async (items) => {
    const withPhoto = (items || []).filter((item) => item?.photo?.path);
    if (!withPhoto.length) {
      setPhotoUrls({});
      return;
    }

    const results = await Promise.allSettled(
      withPhoto.map(async (item) => {
        const data = await userService.obtenerUrlFotoUsuario(
          item.id,
          user.idToken,
        );
        return [item.id, data?.url || null];
      }),
    );

    const nextUrls = {};
    results.forEach((result) => {
      if (result.status === "fulfilled") {
        const [id, url] = result.value;
        if (url) nextUrls[id] = url;
      }
    });
    setPhotoUrls(nextUrls);
  };

  const fetchData = async () => {
    setLoading(true);

    try {
      const usuariosData = await userService.consultarUsuarios(user.idToken);
      const items = usuariosData.Items || [];
      setUsuarios(items);
      await loadPhotoUrls(items);
    } catch (error) {
      console.error("Error al obtener usuarios:", error);
      message.error("Error al cargar los usuarios");
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const columns = [
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      fixed: "left",
      search: true,
      sorter: (a, b) => a.email.localeCompare(b.email),
      filters: getOptions(usuarios, "email"),
      onFilter: (v, record) => record.email.indexOf(v) === 0,
      render: (email, record) => (
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <Avatar
            size={28}
            src={photoUrls[record.id]}
            icon={
              photoUrls[record.id] ? (
                <UserOutlined />
              ) : (
                <UserSwitchOutlined
                  style={{
                    color: record.isActive ? "#52c41a" : "#ff4d4f",
                  }}
                />
              )
            }
            style={{
              backgroundColor: photoUrls[record.id] ? undefined : "#f5f5f5",
            }}
          />
          <span>{email}</span>
        </div>
      ),
    },
    {
      title: "Documento",
      dataIndex: "document",
      key: "document",
      sorter: (a, b) => a.document.localeCompare(b.document),
    },
    {
      title: "Teléfono",
      dataIndex: "phone",
      key: "phone",
    },
    {
      title: "Rol",
      dataIndex: "role",
      key: "role",
      render: (role) => {
        const getRoleColor = (role) => {
          switch (role) {
            case "Administrador":
              return "default";
            case "Coordinador":
              return "default";
            case "Inspector":
              return "default";
            case "Analista":
            case "Analista de Zona":
              return "default";
            case "Operador de Estación":
            case "Auxiliar de Operador de Estación":
              return "default";
            case "Personal Policía Metro":
              return "default";
            case "Personal Vigilancia Privada":
              return "default";
            default:
              return "default";
          }
        };

        return <Tag color={getRoleColor(role)}>{role}</Tag>;
      },
      filters: [
        { text: "Administrador", value: "Administrador" },
        { text: "Coordinador", value: "Coordinador" },
        { text: "Inspector", value: "Inspector" },
        { text: "Analista", value: "Analista" },
        { text: "Analista de Zona", value: "Analista de Zona" },
        { text: "Operador de Estación", value: "Operador de Estación" },
        {
          text: "Auxiliar de Operador de Estación",
          value: "Auxiliar de Operador de Estación",
        },
        { text: "Personal Policía Metro", value: "Personal Policía Metro" },
        {
          text: "Personal Vigilancia Privada",
          value: "Personal Vigilancia Privada",
        },
      ],
      onFilter: (value, record) => record.role === value,
    },
    {
      title: "Team",
      dataIndex: "team",
      key: "team",
      render: (team) => (
        <Tag color={team === "CISE" ? "blue" : team === "EMER" ? "purple" : "default"}>
          {team || "Sin asignar"}
        </Tag>
      ),
      filters: [
        { text: "CISE", value: "CISE" },
        { text: "EMER", value: "EMER" },
      ],
      onFilter: (value, record) => record.team === value,
    },

    {
      title: "Acciones",
      key: "actions",
      width: 100,
      fixed: "right",
      render: (_, record) => (
        <Space size="small">
          <MenuBotonUsuarios item={record} fetchData={fetchData} />
        </Space>
      ),
    },
  ];

  return (
    <>
      <Card
        title={<PageHeader head=" " title="Lista de usuarios"></PageHeader>}
        // extra={<ModalCrearUsuario fetchData={fetchData} />}
      >
        <Table
          columns={columns}
          dataSource={usuarios}
          loading={loading}
          rowKey="id"
          pagination={{
            showSizeChanger: true,
            showQuickJumper: true,
            showTotal: (total, range) =>
              `${range[0]}-${range[1]} de ${total} usuarios`,
            pageSizeOptions: ["10", "20", "50", "100"],
            defaultPageSize: 20,
          }}
          locale={{
            filterTitle: "Filtrar",
            filterConfirm: "Aceptar",
            filterReset: "Limpiar",
            emptyText: "Sin datos",
          }}
        />
      </Card>

      {/* Modal de detalles del usuario */}
    </>
  );
};

export default ListaUsuarios;
